import React, { useEffect } from 'react';
import { translate } from 'react-i18next';
import { EmptyState, TextButton } from 'wix-style-react';
import ChevronRightSmall from 'wix-ui-icons-common/ChevronRightSmall';
import { ServicesProvider } from '@wix/experts-common';
import { goToAutoBrief } from '../../../utils/goToBrief';

function ExploreEmptyState(
  { t, filters, staticsBaseUrl },
  { services: { withBI } },
) {
  useEffect(() => {
    withBI({
      evid: 143,
      typeid: 1,
      filterValue: JSON.stringify(filters),
    });
  }, [filters, withBI]);

  return (
    <EmptyState
      dataHook="explore-empty-state"
      image={<img src={`${staticsBaseUrl}assets/images/illustration.svg`} />}
      theme="page-no-border"
      title={t('client-exploreexperts-emptystate-title')}
      subtitle={t('client-exploreexperts-emptystate-text1')}
    >
      <TextButton
        suffixIcon={<ChevronRightSmall />}
        dataHook="find-me-an-expert-button"
        onClick={() => {
          goToAutoBrief({ target: '_blank' });
        }}
      >
        {t('client-exploreexperts-emptystate-cta')}
      </TextButton>
    </EmptyState>
  );
}

ExploreEmptyState.contextTypes = ServicesProvider.childContextTypes;
export default translate()(ExploreEmptyState);
